import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../Webservices/api';


export const fetchAllTimetable = createAsyncThunk(
  "timetable/fetchAllTimetable",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();

    const schoolId = state.masterData.school_id;
    const userId = state.authSlice?.user?.id;
    const isIndividualLogin = state.authSlice?.user.roles === 'teacher';

    const response = await api.get(
      `/timetable/${schoolId}`,
      {
        params: userId && isIndividualLogin ? { user_id: userId } : {},
      }
    );

    return response.data.data;
  }
);

export const generateTimetable = createAsyncThunk(
  'timetable/generateTimetable',
  async (sectionId) => {
    const response = await api.post(`/timetable/generate/${sectionId}`);
    return response.data;
  }
);

export const generateAllTimetables = createAsyncThunk(
  'timetable/generateAllTimetables',
  async (body) => {
    const response = await api.post(`/timetable/generate-all`,body);
    return response.data;
  }
);

export const fetchTeacherTimetable = createAsyncThunk(
  'timetable/fetchTeacherTimetable',
  async (teacherId,thunkAPI) => {
     const state = thunkAPI.getState();
    const schoolId = state.masterData.school_id;
    const response = await api.get(`/timetable/teacher/${teacherId}/${schoolId}`);
    return response.data;
  }
);


export const updateTimetable = createAsyncThunk(
  'timetable/updateTimetable',
  async (data,thunkAPI) => {

    try{
    const response = await api.post(`/timetable/update`,data);
    return response.data.data;
    }
 catch (error) {
      console.error("Error updating timetable:", error);
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);



const timetableSlice = createSlice({
  name: 'timetable',
  initialState: {
    timetable: [],
    teacherTimetable: [],
    generationStatus: [],
    loading: false,
    error: null,
  },
  reducers: {
     toggleEditPeriodMode: (state) => {
      state.editMode = !state.editMode;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllTimetable.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllTimetable.fulfilled, (state, action) => {
        state.loading = false;
        state.timetable = action.payload;
      })
      .addCase(fetchAllTimetable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(generateTimetable.fulfilled, (state, action) => {
        state.timetable = action.payload;
      })
      .addCase(generateAllTimetables.pending, (state) => {
        state.loading = true;
        state.generationStatus = [];
      })
      .addCase(generateAllTimetables.fulfilled, (state, action) => {
        state.loading = false;
        state.generationStatus = action.payload.results;
      })
      .addCase(generateAllTimetables.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchTeacherTimetable.fulfilled, (state, action) => {
        state.teacherTimetable = action.payload;
      })

      .addCase(updateTimetable.pending, (state, action) => {
        state.loading = true;
       
      })
      .addCase(updateTimetable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateTimetable.fulfilled, (state, action) => {
        state.teacherTimetable = action.payload;
      });
  },
});

export const {toggleEditPeriodMode}=timetableSlice.actions

export default timetableSlice.reducer;